import CreateVendorDealerLocationModal from "./CreateVendorDealerLocationModal";

export default CreateVendorDealerLocationModal;